// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
//import firebase from 'firebase/app';
import 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';



const firebaseConfig = {
    apiKey: "AIzaSyA1uVGYzV4gcL-UpVw5FMkV1dH4srS_F6o",
    authDomain: "the-climate-spectrum-60f5c.firebaseapp.com",
    projectId: "the-climate-spectrum-60f5c",
    storageBucket: "the-climate-spectrum-60f5c.appspot.com",
    messagingSenderId: "105321536850",
    appId: "1:105321536850:web:5e58ad3fd3bbdd125bee8b",
    measurementId: "G-HM0Q7RDV72"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export const updateArticleVotes = async (articleId, newCount) => {
    // Add debug logging
    console.log('Attempting to update article:', articleId, 'with count:', newCount);
    
    if (!articleId) {
        throw new Error('No article ID provided');
    }

    try {
        const articleRef = doc(db, 'articles', articleId.toString());
        console.log('Article reference:', articleRef);
        
        await updateDoc(articleRef, {
            insightfulCount: newCount
        });
        
        console.log('Successfully updated article votes');
    } catch (error) {
        console.error('Error in updateArticleVotes:', error);
        throw error;
    }
};

export { auth };

export default db;
